<template>
  <div class="subject-box start-exam">
    <el-row :gutter="30">
      <el-col :span="span1">
        <div class="subject-box-card">
          <div class="subject-exam-title">错题本</div>
  
          <!-- 题目内容 -->
          <choices ref="choices" v-show="this.subject.type === 0" />
          <short-answer ref="shortAnswer" v-show="this.subject.type === 1" />
          <judgement ref="judgement" v-show="this.subject.type === 2" />
          <multiple-choices ref="multipleChoices" v-show="this.subject.type === 3" />
  
          <div v-if="subjectTotal>0">
            <!-- 查看解析按钮 -->
            <div class="view-analysis-btn" v-if="!showAnalysis">
              <el-button type="primary" @click="handleViewAnalysis" :loading="loadingAnalysis">
                <i class="el-icon-view"></i> 查看解析
              </el-button>
            </div>
  
            <!-- 解析展示区域 -->
            <div class="subject-analysis" v-if="showAnalysis && analysisResult">
              <div class="analysis-header">
                <span class="analysis-title">题目解析</span>
                <el-button type="text" @click="showAnalysis = false">
                  <i class="el-icon-close"></i> 收起
                </el-button>
              </div>
  
              <div class="answer-result" :class="analysisResult.correct ? 'correct' : 'incorrect'">
                <i :class="analysisResult.correct ? 'el-icon-success' : 'el-icon-error'"></i>
                {{ analysisResult.correct ? '回答正确' : '回答错误' }}
              </div>
  
              <div class="answer-section">
                <p><strong>你的答案：</strong> {{ analysisResult.userAnswer || '未作答' }}</p>
                <p><strong>正确答案：</strong> {{ analysisResult.correctAnswer }}</p>
              </div>
  
              <div class="analysis-content">
                <p><strong>解析：</strong></p>
                <div v-html="analysisResult.analysis"></div>
              </div>
            </div>
            <div class="subject-buttons" v-if="query.subjectId !== ''">
              <el-button plain @click="last" :loading="loadingLast">上一题</el-button>
              <el-button plain @click="next" :loading="loadingNext">下一题</el-button>
            </div>
          </div>
          <div v-else>
            <el-empty ></el-empty>
          </div>
  
        </div>
      </el-col>
      <el-col :span="span2">
        <div class="tool-bar">
  
  
  
          <div class="paper-info">
            题目总数: 共{{subjectTotal}}题
          </div>
  
  
  
  
  
          <div class="answer-card">
  
            <el-row class="answer-card-content">
              <el-button :class="{ 'answered': subjectIds[index].answered }" circle v-for="(value, index) in subjectIds"
                :key="index" @click="toSubject(value.subjectId, value.type, index)">&nbsp;{{index + 1}}&nbsp;</el-button>
            </el-row>
  
          </div>
  
  
  
  
  
  
  
  
        </div>
      </el-col>
    </el-row>
    <el-dialog title="答题卡" :visible.sync="dialogVisible" width="50%" top="10vh" center>
      <div class="answer-card-title">{{exam.examinationName}}（共{{subjectIds.length}}题，合计{{exam.totalScore}}分）</div>
      <div class="answer-card-split"></div>
      <el-row class="answer-card-content">
  
  
        <el-button :class="{ 'answered': subjectIds[index].answered }" circle v-for="(value, index) in subjectIds"
          :key="index" @click="toSubject(value.subjectId, value.type, index)">&nbsp;{{index + 1}}&nbsp;</el-button>
  
      </el-row>
    </el-dialog>
  </div>
</template>
<script>

const { body } = document;
const WIDTH = 1060;
// 导入UUID库
import uuidv4 from 'uuid/dist/v4';
import { throttle } from 'lodash';
// const { v4: uuidv4 } = require('uuid');
// uuidv4(); // ⇨ '1b9d6bcd-bbfd-4b2d-9b5d-ab8dfbbd4be
import { mapState, mapGetters } from 'vuex'
import CountDown from 'vue2-countdown'
import { practicing, answerQuestions } from '@/api/exam/examnotebook'
import store from '@/store'
import moment from 'moment'
import { messageSuccess, messageFail, messageWarn, isNotEmpty } from '@/utils/util'
import Tinymce from '@/components/Tinymce'
import Choices from '@/components/Subjects/Choices'
import MultipleChoices from '@/components/Subjects/MultipleChoices'
import ShortAnswer from '@/components/Subjects/ShortAnswer'
import Judgement from '@/components/Subjects/Judgement'
import { nextSubjectType } from '@/const/constant'

export default {
  components: {
    CountDown,
    Tinymce,
    Choices,
    MultipleChoices,
    ShortAnswer,
    Judgement
  },
  data() {
    return {
      span1: 18,
      span2: 5,
      loadingLast: false,
      loadingNext: false,
      loadingSubmit: false,
      currentTime: 0,
      startTime: 0,
      endTime: 0,
      disableSubmit: true,
      subjectIndex: 1,
      lastSubjectIndex: 1,
      query: {

        type: '', id: ''
      },
      subject: {
        type: 0
      },
      option: '',
      answer: '',
      dialogVisible: false,
      tempAnswer: {
        id: null,
        userId: null,
        examinationId: null,
        courseId: null,
        subjectId: null,
        answer: null,
        type: 0
      },
      subjectIds: [],
      subjectStartTime: undefined,
      subjectTotal: 0,
      currentSubjectIndex: 0,
      curretFlag: '',

      showAnalysis: false,      // 控制解析显示状态
      analysisResult: {
        correct: false,        // 是否正确
        userAnswer: '',
        correctAnswer: '',
        analysis: ''
      },     // 存储解析结果
      loadingAnalysis: false,   // 解析加载状态
      sessionId: '', // 新增：唯一会话标识
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    }),
    ...mapGetters([
      'exam', 'examRecord'
    ])
  },
  created() {
    // 生成唯一会话标识
    this.sessionId = uuidv4();
    console.log(this.sessionId, 'sessionId')
    this.resizeHandler()
    this.loadNextSubject()

  },
  beforeMount() {
    window.addEventListener('resize', this.resizeHandler)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler)
  },
  methods: {
    // 加载下一题的方法
    async loadNextSubject() {
      // 重置解析相关状态
      this.showAnalysis = false;

      try {
        const response = await practicing({
          type: this.curretFlag,
          id: this.query.id,
          sessionId: this.sessionId
        });

        if (response.data) {
          const subject = response.data.subjectVO;
          this.subjectTotal = response.data.subjectTotal;
          this.subject.type = this.query.type = subject.type;
          this.query.id = subject.id;
          this.query.analysis = subject.analysis;
          this.tempAnswer = subject.answer;
          this.$nextTick(() => {
            this.setSubjectInfo(subject);
          });
        }
      } catch (error) {
        // messageFail(this, '获取题目失败');
      }
    },

    last: throttle(async function() {
      this.curretFlag = 0;
      // 不需要保存，直接加载上一题
      if (this.currentSubjectIndex <= 0) {
        messageSuccess(this, '已经是第一题了');
        return;
      }

      this.currentSubjectIndex--;
      await this.loadNextSubject();
    }, 1000,{ trailing: false }),
   next: throttle(async function() {
      this.curretFlag = 1;
      // 先保存当前题目
      // await this.saveCurrentAnswer();
      // 检查是否是最后一题
      if (this.currentSubjectIndex >= this.subjectTotal - 1) {
        messageSuccess(this, '已经是最后一题了');
        return;
      }
      this.currentSubjectIndex++;
      // 加载下一题
      await this.loadNextSubject();
      window.scroll(0, 0);
    }, 1000,{ trailing: false }),
    // 新增：查看解析方法
    async handleViewAnalysis() {
      this.loadingAnalysis = true;
      try {
        const answerId = isNotEmpty(this.tempAnswer) ? this.tempAnswer.id : ''
        const answer = await this.getAnswer(answerId)
        console.log('answer', answer);
        this.analysisResult.userAnswer = answer.answer || ''

        // 获取解析结果
        const response = await this.getAnalysis(this.analysisResult.userAnswer);

        // 设置解析结果并显示
        this.analysisResult.correct = response.data.result;
        this.analysisResult.correctAnswer = response.data.answer;
        this.analysisResult.analysis = response.data.analysis;
        console.log('解析结果：', this.analysisResult);
        this.showAnalysis = true;
      } catch (error) {
        console.log(error, 'error')
        // messageFail(this, '获取解析失败');
      } finally {
        this.loadingAnalysis = false;
      }
    },
    // 获取解析方法
    async getAnalysis(answer) {


      // 调用API获取解析
      return answerQuestions({
        answer: answer,
        id: this.query.id,
        sessionId: this.sessionId
      });
    },
    // 新增：保存当前答案的方法
    async saveCurrentAnswer() {
      const answerId = isNotEmpty(this.tempAnswer) ? this.tempAnswer.id : ''
      const answer = this.getAnswer(answerId)
      console.log('answer', answer);
      try {
        await answerQuestions({
          answer: answer.answer,
          id: this.query.id,
          sessionId: this.sessionId
        });
      } catch (error) {
        messageFail(this, '保存答案失败');
      }
    },
    // 根据题目类型返回填写的答案
    async getAnswer(answerId) {
      await this.$nextTick();
      const ref = this.getSubjectRef()
      console.log('ref', ref)
      if (isNotEmpty(ref)) {
        const answer = ref.getAnswer()
        console.log('answ5555555555555555555555er', answer)
        this.answer = answer
        return {
          id: answerId,
          userId: this.userInfo.id,
          examinationId: this.query.examinationId,
          examRecordId: this.query.examRecordId,
          subjectId: this.query.subjectId,
          answer: answer,
          type: this.query.type,
        }
      }
      return {}
    },
    // 获取题目索引
    getSubjectIndex(targetId) {
      for (let subject of this.subjectIds) {
        let { subjectId, index } = subject
        if (subjectId === targetId) {
          return index
        }
      }
      return 1
    },
    // 更新题目索引
    updateSubjectIndex() {
      this.subjectIndex = this.getSubjectIndex(this.query.subjectId)
    },
    startLoading(nextType) {
      if (nextType === nextSubjectType.next) {
        this.loadingNext = true
      } else if (nextType === nextSubjectType.last) {
        this.loadingLast = true
      } else {
        this.loadingNext = true
      }
    },
    endLoading(nextType) {
      if (nextType === nextSubjectType.next) {
        this.loadingNext = false
      } else if (nextType === nextSubjectType.last) {
        this.loadingLast = false
      } else {
        this.loadingNext = false
      }
    },
    getSubjectRef() {
      let ref
      switch (this.query.type) {
        case 0:
          ref = this.$refs.choices
          break
        case 1:
          ref = this.$refs.shortAnswer
          break
        case 2:
          ref = this.$refs.judgement
          break
        case 3:
          ref = this.$refs.multipleChoices
          break
      }
      return ref
    },
    setSubjectInfo(subject) {
      const ref = this.getSubjectRef()
      if (isNotEmpty(ref)) {
        try {
          ref.setSubjectInfo({
            ...subject,
            analysis: this.query.analysis // 确保传递解析内容
          }, this.subjectTotal, this.currentSubjectIndex + 1)
        } catch (error) {
          console.error(error)
        }
      }
    },
    isMobile() {
      const rect = body.getBoundingClientRect();
      var isMobile = rect.width - 1 < WIDTH;

      return isMobile;
    },
    resizeHandler() {
      if (document.hidden) {
        return;
      }

      const isMobile = this.isMobile();

      if (isMobile) {
        this.span1 = 23;
        this.span2 = 23;
      } else {
        this.tableSpan = 18;
        this.tableOffset = 5;
      }


    },



  }
}
</script>

<style>
.start-exam .subject-content {
  width: 100%;
  text-align: left;
}

.start-exam .subject-options>li .toggle+label {
  text-align: left;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss" scoped>
.subject-exam-title {
  width: 100%;
  font-size: 1.3rem;
  text-align: center;
  font-weight: bold;
}

.subject-exam-subtitle {
  width: 100%;
  font-size: 1.1rem;
  text-align: center;
  margin-top: 1rem;
  margin-bottom: 1.5rem;
}

.subject-box {
  margin-top: 50px;
  margin-left: 20px;
}

.subject-box-card {
  margin-bottom: 30px;
  min-height: 400px;
}

.subject-buttons {
  text-align: center;
}

.tool-bar {
  margin-left: 20px;
}

.time-remain .time {
  display: inline-block;
  font-size: 18px;
  line-height: 22px;
  color: #FF0000;
  font-weight: 400;
}

/* 答题卡 */
.answer-card-title {
  font-size: 13px;
  color: #3A3E51;
  line-height: 17px;
  padding: 10px 0;
}

.answer-card-split {
  width: 100%;
  border-bottom: 1px solid #E6E6E6;
}

.answer-card-content {
  padding-bottom: 10px;
  font-size: 0;
  margin-right: -15px;

  >button {
    width: 42px;
    padding-left: 0;
    padding-right: 0;
    text-align: center;
    margin-top: 5px;
    margin-left: 0px !important;
    margin-right: 10px !important;
  }
}

.paper-info {
  margin-top: 10px;
}

.answered {
  background-color: greenyellow;
}

/* 新增查看解析按钮样式 */
.view-analysis-btn {
  margin: 25px 0;
  text-align: left;
}

/* 新增解析内容样式 */
.subject-analysis {
  margin: 30px;

  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #409EFF;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
}

.analysis-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eaeaea;
}

.analysis-title {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}

.answer-result {
  padding: 10px 15px;
  border-radius: 4px;
  font-weight: 500;
  margin-bottom: 15px;
}

.answer-result.correct {
  background-color: rgba(103, 194, 58, 0.1);
  color: #67C23A;
}

.answer-result.incorrect {
  background-color: rgba(245, 108, 108, 0.1);
  color: #F56C6C;
}

.answer-result i {
  margin-right: 8px;
  font-size: 18px;
}

.answer-section {
  margin-bottom: 15px;
  padding: 15px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}

.answer-section p {
  margin: 8px 0;
  font-size: 15px;
}

.analysis-content {
  padding: 15px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}

.analysis-content p {
  margin-bottom: 10px;
}
</style>
